<div class="page-container">
  <div class="content">
    <div class="content-header">
      <h2 translate>learnset.heading</h2>
      <app-button [routerLink]="'/sets/create'" [text]="'learnset.create' | translate"></app-button>
    </div>
    <div class="set-grid">
      <app-learnset-widget *ngFor="let learnset of learnsets" [learnset]="learnset" [routerLink]="'/sets/' + learnset.id"></app-learnset-widget>
    </div>
  </div>
</div>